import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu } from '@radix-ui/themes';
import { CubeIcon, CylinderIcon, SphereIcon } from '@phosphor-icons/react';
import { useTranslation } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
const TOOLS = [
    { id: 'cube3d', titleKey: 'toolbar.tools.cube3d', icon: CubeIcon },
    { id: 'sphere3d', titleKey: 'toolbar.tools.sphere3d', icon: SphereIcon },
    { id: 'box3d', titleKey: 'toolbar.tools.box3d', icon: CubeIcon },
    { id: 'cylinder3d', titleKey: 'toolbar.tools.cylinder3d', icon: CylinderIcon },
    { id: 'prism3d', titleKey: 'toolbar.tools.prism3d', icon: CubeIcon },
    { id: 'mesh3d', titleKey: 'toolbar.tools.mesh3d', icon: CubeIcon },
];
export function ThreeDTools() {
    const { t } = useTranslation();
    const { currentTool, setTool } = useEditorStore();
    const activeTool = TOOLS.find((tool) => tool.id === currentTool);
    const is3DActive = TOOLS.some((tool) => tool.id === currentTool);
    const TriggerIcon = activeTool?.icon ?? CubeIcon;
    return (_jsx("div", { className: "three-d-tools", children: _jsxs(DropdownMenu.Root, { children: [_jsx(DropdownMenu.Trigger, { children: _jsxs(Button, { variant: "soft", radius: "none", size: "3", className: `three-d-tools-trigger ${is3DActive ? 'active' : ''}`, "aria-label": t('toolbar.objects3d'), children: [_jsx(TriggerIcon, { "aria-hidden": "true", weight: is3DActive ? 'fill' : 'regular' }), _jsx(CaretDownIcon, { "aria-hidden": "true", className: "three-d-tools-chevron" })] }) }), _jsx(DropdownMenu.Content, { variant: "soft", size: "2", align: "start", sideOffset: 4, children: TOOLS.map((tool) => {
                        const Icon = tool.icon;
                        const isActive = currentTool === tool.id;
                        return (_jsxs(DropdownMenu.Item, { onSelect: () => setTool(tool.id), className: isActive ? 'three-d-tools-item-active' : undefined, children: [_jsx(Icon, { "aria-hidden": "true", weight: isActive ? 'fill' : 'regular' }), t(tool.titleKey)] }, tool.id));
                    }) })] }) }));
}
